import classNames from 'classnames';

export interface Props
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt?: string;
  title?: string;
  cover?: boolean;
  rounded?: boolean;
  shadow?: boolean;
  className?: string;
}

function Image({
  src,
  alt = '',
  title,
  cover = false,
  rounded = false,
  shadow = false,
  className,
  ...rest
}: Props) {
  return (
    <img
      src={src}
      alt={alt}
      title={title || alt}
      className={classNames([
        className,
        cover &&
          'absolute inset-0 h-full w-full object-cover object-center',
        rounded && 'rounded-xl',
        shadow && 'shadow-img-depth-1'
      ])}
      {...rest}
    />
  );
}

export default Image;
